var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.998 11.5H12.998V5.5C12.998 5.23478 12.8927 4.98043 12.7052 4.79289C12.5176 4.60536 12.2633 4.5 11.998 4.5C11.7328 4.5 11.4785 4.60536 11.2909 4.79289C11.1034 4.98043 10.998 5.23478 10.998 5.5V11.5H4.99805C4.73283 11.5 4.47848 11.6054 4.29094 11.7929C4.1034 11.9804 3.99805 12.2348 3.99805 12.5C3.99805 12.7652 4.1034 13.0196 4.29094 13.2071C4.47848 13.3946 4.73283 13.5 4.99805 13.5H10.998V19.5C10.998 19.7652 11.1034 20.0196 11.2909 20.2071C11.4785 20.3946 11.7328 20.5 11.998 20.5C12.2633 20.5 12.5176 20.3946 12.7052 20.2071C12.8927 20.0196 12.998 19.7652 12.998 19.5V13.5H18.998C19.2633 13.5 19.5176 13.3946 19.7052 13.2071C19.8927 13.0196 19.998 12.7652 19.998 12.5C19.998 12.2348 19.8927 11.9804 19.7052 11.7929C19.5176 11.6054 19.2633 11.5 18.998 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a9ddc2f5645e9e7e7f24f3b9860c6954.svg";
export { ForwardRef as ReactComponent };